import React, { useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "components/Layout";
import api from "utils/api";
import { formatPrice } from "constants/massages";
import "styles/booking.css";

const formatDateTime = (date) =>
  new Date(date).toLocaleString("de-DE", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

const BookingSuccessPage = () => {
  const [params] = useSearchParams();
  const location = useLocation();
  const token = useSelector((s) => s.token);
  const bookingId = params.get("bookingId");
  // The booking page passes the booking object via router state for the
  // anonymous consultation flow (where the GET /bookings/:id endpoint
  // requires auth). For authenticated bookings we still fetch the latest
  // server-side state so payment status etc. is up to date.
  const initialBooking = location.state?.booking || null;
  const [booking, setBooking] = useState(initialBooking);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!bookingId || !token) return undefined;
    let cancelled = false;
    api
      .get(`/bookings/${bookingId}`)
      .then(({ data }) => {
        if (!cancelled) setBooking((prev) => data.booking || prev);
      })
      .catch((err) => {
        if (!cancelled && !initialBooking) {
          setError(err?.response?.data?.message || "Buchung nicht gefunden.");
        }
      });
    return () => {
      cancelled = true;
    };
  }, [bookingId, token, initialBooking]);

  return (
    <Layout>
      <section className="booking-page">
        <div className="option-detail" style={{ marginTop: 0 }}>
          <h2>Vielen <em>Dank!</em></h2>
          <p className="step-summary">
            Deine Buchung ist eingegangen. Eine Bestätigungs-E-Mail mit Kalenderdatei (.ics) ist unterwegs.
          </p>

          {error && <div className="auth-alert is-error" style={{ marginBottom: "1rem" }}>{error}</div>}

          {booking && (
            <div className="booking-summary-block" style={{ marginTop: 0, borderTop: "none", paddingTop: 0 }}>
              <div className="summary-row">
                <span>Leistung</span>
                <strong>{booking.serviceLabel}</strong>
              </div>
              <div className="summary-row">
                <span>Dauer</span>
                <strong>{booking.durationMinutes} Min.</strong>
              </div>
              <div className="summary-row">
                <span>Termin</span>
                <strong>{formatDateTime(booking.start)}</strong>
              </div>
              {booking.location && (
                <div className="summary-row">
                  <span>Ort</span>
                  <strong>{booking.location}</strong>
                </div>
              )}
              <div className="summary-row">
                <span>Preis</span>
                <strong>
                  {booking.priceCents === 0 ? "Kostenfrei" : formatPrice(booking.priceCents)}
                </strong>
              </div>
              <div className="summary-row">
                <span>Zahlung</span>
                <strong>
                  {booking.paymentMethod === "stripe"
                    ? `Online (${booking.paymentStatus})`
                    : booking.paymentMethod === "later"
                      ? "Wird beim Termin geklärt"
                      : "Vor Ort"}
                </strong>
              </div>
            </div>
          )}

          <div style={{ marginTop: "2rem", display: "flex", gap: "0.8rem", flexWrap: "wrap" }}>
            {token ? (
              <Link to="/konto" className="btn-primary">Zu meinem Konto</Link>
            ) : (
              <Link to="/buchen" className="btn-primary">Weitere Optionen</Link>
            )}
            <Link to="/" className="btn-ghost">Zur Startseite</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default BookingSuccessPage;
